export const ReactIgnoredProps = Object.freeze([
    'children',
    'key',
    'ref',
]);
